import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'; 
import img1 from './imgs/resources1.jpg';
import placeholder from './imgs/placeholder-image.png';
import Img from '../../widgets/Img';

const Resources = () => {
    

    return (
        <Fragment>
            <div style={jumboStyle} className="jumbotron text-light">
                <div className="container">
                    <h1 style={{fontWeight: '300'}}>Recommended Resources</h1>
                    <p>Recommendations of Products/Services/Companies the author recommends will assist in your process of transformation whether it be in your life or business. These are companies which are going to assist you through their own products or services. Go through the list of businesses which the author recommends for your personal development.</p>
                    <hr className="my-4" />
                    <a style={{marginRight: '1rem'}} className="btn btn-dark btn-lg" href="#" role="button">Learn more</a>
                    <a className="btn btn-danger btn-lg" href="#" role="button">Get Recommended</a>

                </div>
            </div>

            <div className="container center-sm">
                <h3>Your Business Name</h3>
                <div className="row">
                    <div className="col-md">
                        <Img url={placeholder} />
                    </div>
                    <div className="col-md align-center">
                        <div>
                            <p style={{fontSize: '1.2em'}}>[This area is where your businesses description will be]. This opportunity will offer you a spot on the website of the book, which will redirect people onto this platform, from webinars, online events, social media posts, advertising campaigns. There will be your businesses name, a descripton of what your business does, along with an image and a redirect button to help support your business. You’ll also get your very own landing page, which will be promoted on all our social platforms, buy now cards, flyers and even in the book, based off the package you choose.</p>
                            <Link style={{marginTop: '1rem'}} className="btn btn-secondary" to='/contact'>Click Here</Link>
                        </div>
                    </div>

                    
                    
                </div>
            </div>
        </Fragment>
        
    )
}

const jumboStyle = {
    background: `linear-gradient( rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6) ), url(${img1}) no-repeat 0`,
    backgroundSize: 'cover',
    backgroundPosition: 'right',
    borderRadius: '0'
}

export default Resources;
